import { BaseService } from '@flint/framework';

export default class FooterService extends BaseService {
  constructor() {
    super("FETCHING_FOOTER_BOOKS", 'FooterStore', true);
  }

  handleEvent(eventName) {
    return this.getClient('vetService').get('/api/topics/footer-books');
  }
}